const traing_teacher_routes = {
      path: "/teacher",
      name: "Teacher",
      component: () => import("@/components/LayOut/Main"),
      meta: {requiresAuth: true},
      children: [
        // 测评列表页
        {
          path: 'evaluation_list',
          name: 'TeaEvaluationList',
          component: () => import('@/views/training_teacher/EvaluationList'),
          meta: {requiresAuth: true},
        },
        // 测评
        {
          path: 'create_evaluation',
          name: 'TeaCreateEvaluation',
          component: () => import('@/views/training_teacher/Evaluation/CreateEvaluation'),
          meta: {requiresAuth: true},
        },
        // 测评详情页
        {
          path: 'evaluation_detail',
          name: 'TeaShowEvalua',
          component: () => import('@/views/training_teacher/Evaluation/ShowEvalua'),
          meta: {requiresAuth: true},
        },
        {
          path: "class",
          component: () => import('@/views/training_teacher/class-list'),
          meta: {requiresAuth: true},
        },
        {
          path: "tea_cd",
          component: () => import('@/views/training_teacher/class-detail'),
          meta: {requiresAuth: true},
        },
        {
          path: "tea_sd",
          component: () => import('@/views/training_teacher/stu-detail'),
          meta: {requiresAuth: true},
        },
        {
          path: "won",
          component: () => import('@/views/training_teacher/Wonderful'),
          meta: {requiresAuth: true},
        },
        // 讲师完善个人信息页
        {
          path:'vita',
          component: () => import('@/views/training_teacher/vita/vita'),
          meta: {requiresAuth: true},
        },
        /* --------------单个学员教案--------------- */
        {
          path: "stu_tutorial",
          component: () => import('@/views/training_teacher/student-tutorial'),
          meta: {requiresAuth: true},
        },
        /*--------------全部学员教案-----------------*/
        {
          path: "stus_tutorial",
          component: () => import('@/views/training_teacher/stus-tutorial'),
          meta: {requiresAuth: true},
        },
        {
          path: "tutorial_detail",
          component: () => import('@/components/Tutorial/tutorial-detail'),
          meta: {requiresAuth: true},
        },
        {
          path: "upload_score",
          component: () => import('@/components/score/upload-score'),
          meta: {requiresAuth: true},
        },
        { // 五人制上传成绩报告单
          path: "upload_score_report_five",
          component: () => import('@/components/score/five-upload-score-report'),
          meta: {requiresAuth: true},
        },
        {
          path: "upload_score_education",
          component: () => import('@/components/score/upload-score-education'),
          meta: {requiresAuth: true},
        },
        {
          path: "look_score",
          component: () => import('@/components/score/score-detail'),
          meta: {requiresAuth: true},
        },
        {
          path: "class_report",
          component: () => import('@/components/score/class-report'),
          meta: {requiresAuth: true},
        },
        {
          path: "class_report_assistant",
          component: () => import('@/components/score/class-report-assistant'),
          meta: {requiresAuth: true},
        },
        {
          path: "tran_his",
          name: 'TrainingHis',
          component: () => import('@/views/TraingingManager/TrainingHis/TrainingHis'),
          meta: {requiresAuth: true},
        },
        {
          path: "create_tutorial",
          component: () => import('@/views/training_student/create-tutorial'),
          meta: {requiresAuth: true},
        },
        {
          path: "tutorial_list",
          component: () => import('@/views/training_teacher/tutorial'),
          meta: {requiresAuth: true},
        },
        {
          path: "edit_tutorial",
          component: () => import('@/views/training_student/edit-tutorial'),
          meta: {requiresAuth: true},
        },
        {
          path:"registrationList",
          component: () => import("@/views/Registration/registration-list-teacher"),
          meta:{requiresAuth:true}
        },
        // 报名详情
        {
          path: "register_info",
          component: () => import('@/components/Registration/RegistrationInfo'),
          meta: {requiresAuth: true},
        },
        // 上传附件
        {
          path: "register_file",
          component: () => import('@/views/Registration/vita/vitaFile'),
          meta: {requiresAuth: true},
        },
        // 查看某个学员的学习详情
        {
          path: "student_study_learn_view",
          component: () => import("@/views/system_manager/education/studentStudyLearnView"),
          meta: {requiresAuth: true}
        },
        // 讲师简历 信息返回
        {
          path: "teacher_resume_info",
          component: () => import("@/views/training_teacher/teacher-resume"),
          meta: {requiresAuth: true}
        },
        // 文件存档
        {
          path:'documents',
          component: () => import('@/views/Documents/Documents'),
          meta: {requiresAuth: true}
        },
      ]
    }

export default traing_teacher_routes;
